export default __webpack_public_path__ + "locales/de/InviteDialog.json?hash=ca963ac24eecb63df30f14e72f6de3a2";